import {UserActivityEvent} from "./UserActivityTypes";

export default class UserActivity {
  public activityScore: number = 0
  public maxScore: number = 0
  public activityHistory: UserActivityEvent[] = []
  public activityHistoryByDay: UserActivityEvent[] = []
  public activityHistoryByWeek: UserActivityEvent[] = []
  public eventCounts: {regularity: number, challenges:number, pieces: number, modules: number, connections: number} =
  {regularity: 0, challenges: 0, pieces: 0, modules: 0, connections: 0}
  public lastConnection: string = ''

  updateDataFromJson(data: any) {
    this.activityScore = data.activity_score;
    this.maxScore = data.max_score;
    this.activityHistory = data.activity_history
    this.activityHistoryByDay = data.activity_history_by_day
    this.activityHistoryByWeek = data.activity_history_by_week
    this.eventCounts = data.event_counts
    this.lastConnection = data.last_connection
  }
}
